import { useEffect, useState } from 'react';

const LOOP_MS = 250;

/**
 * This hook will watch for the global OneTrust object (used for cookie banner) and set a flag when
 * it is defined. You can then access the OneTrust API via window.OneTrust.
 */
export const useOneTrust = () => {
  const [isReady, setIsReady] = useState(!!window.OneTrust);

  // Watch for SBC config being loaded
  useEffect(() => {
    if (!isReady) {
      const loop = window.setInterval(() => {
        setIsReady(!!window.OneTrust);
      }, LOOP_MS);
      return () => {
        window.clearInterval(loop);
      };
    }
  }, [isReady]);

  return {
    isLoading: !isReady,
    isReady
  };
};
